module.exports = "/_next/static/images/72a3721fad6ebad35206e44b06326f8f-withdrawal.svg";